import { render, staticRenderFns } from "./storeByProjectOrder.vue?vue&type=template&id=f4fba388&scoped=true"
import script from "./storeByProjectOrder.vue?vue&type=script&lang=js"
export * from "./storeByProjectOrder.vue?vue&type=script&lang=js"
import style0 from "./storeByProjectOrder.vue?vue&type=style&index=0&id=f4fba388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fba388",
  null
  
)

export default component.exports